import { Button, Pagination, Space, Table } from 'antd';
import Column from 'antd/es/table/Column';
import { useSelector } from 'react-redux';
import {
	AddSvg,
	EditActionSvg,
	SortBottomIcon,
	SortTopIcon,
	TableNextIcon,
	TablePreviousIcon
} from 'utils/svgs';
import { checkPermission } from 'utils/utils';
import SearchAndFilter from '../SearchAndFilter';
import styles from './index.module.scss';
import './index.scss';


const CustomTable = ({
	dataSource, handleTableChange, onShowSizeChange, isLoading, search, totalRecords, performSearchHandler, performFilterHandler, filterValue, openDrawerHandler, setDrawerInfoHandler, setEditSelectedSubscription, showModal, currentPage, pageSize, isSearchCancel, setSearch, setIsSearchCancel, fetchSubscription, setSelectedRowData }: any) => {


	const userPermissions = useSelector(
		(state: any) => state?.userProfile
	);
	const isEditPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Subscription',
		permission: ['edit'],
	});

	const isDeletePermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Subscription',
		permission: ['delete'],
	});
	const isAddPermission = checkPermission(userPermissions?.data?.permissions, {
		permissionName: 'Subscription',
		permission: ['add'],
	});

	const editDataHandler = (deviceObject: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Subscription');
		setEditSelectedSubscription(deviceObject);
	};

	return (
		<>
			<div className={`${styles['body']} user-table`} >
				<SearchAndFilter
					performSearchHandler={performSearchHandler}
					searchValue={search}
					performFilterHandler={performFilterHandler}
					filterValue={filterValue}
					title={'Subscription List'}
					isSearchCancel={isSearchCancel}
					setSearch={setSearch}
					setIsSearchCancel={setIsSearchCancel}
				/>

				<Table
					rowKey={(record: any) => record?.id}
					dataSource={dataSource}
					pagination={false}
					loading={isLoading}
					onChange={handleTableChange}
					scroll={{ y: 'calc(100vh - 300px)' }}
				>
					<Column
						title={<p style={{ paddingRight: '10px' }}>Name</p>}
						dataIndex="name"
						key="name"
						className="user-column bg-white"
						width={'8%'}
						sorter
						sortDirections={['ascend', 'descend', 'ascend']}
						render={(value: any) => (value ? value : '-')}
						sortIcon={({ sortOrder }) => {
							const isAscend = sortOrder === 'ascend';
							const isDescend = sortOrder === 'descend';

							return (
								<>
									<SortTopIcon fill={isAscend ? '#949494' : undefined} />
									<SortBottomIcon fill={isDescend ? '#949494' : undefined} />
								</>
							);
						}}
					/>

					<Column
						title="Mac Address"
						dataIndex="macAddress"
						key="macAddress"
						className="bg-white"
						width={'12%'}
						render={(value: any) => (value ? value : '-')}
					/>


					<Column
						title="Status"
						dataIndex="status"
						key="status"
						className="bg-white"
						width={'8%'}
						render={(value: any) => (value ? value : '-')}
					/>

					<Column
						title="Subscription"
						dataIndex="company"
						key="company"
						className="bg-white"
						width={'10%'}
						render={(value, data: any) => {
							return (
								<Space size={20}>
									{(isAddPermission && (userPermissions?.data?.isSuperAdmin || userPermissions?.data?.isAdmin)) ? (
										<Button
											className={` ${styles['user-table__action--button']}`}
											onClick={() => {
												openDrawerHandler();
												setSelectedRowData(data);
											}}
											disabled={data?.subscriptions?.length > 0}
										>

											<p>
												{data?.subscriptions?.length > 0 ? (
													'Already subscribed !!!'
												) : (
													<>
														+	Add Subscription
													</>
												)}
											</p>

										</Button>
									) : (
										<Button
											className={` ${styles['user-table__action--button']}`}
											disabled
										>
											<AddSvg />
											<p>Add Subscription</p>
										</Button>

									)}
								</Space>

							);
						}}
					/>

					{(isEditPermission || isDeletePermission) && (
						<Column
							title="Action"
							dataIndex="action"
							key="action"
							className="bg-white"
							width={'8%'}
							render={(value, data: any) => {
								return (
									<Space size={20}>
										{((isEditPermission || userPermissions?.data?.isSuperAdmin) && !data.isClientModeOn) ?
											(<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn"
												onClick={() =>
													editDataHandler(data)
												}
											>
												<EditActionSvg />
											</div>
											) : (
												<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn">

													<EditActionSvg />
												</div>
											)}

										{/* {(isDeletePermission && userPermissions?.data?.isSuperAdmin) ? (
											<div
												className="cursor-pointer flex align-center justify-center rounded-action-btn "
												onClick={() =>
													deleteDataHandler(data)
												}
											>
												<DeleteActionSvg />
											</div>
										) : (
											<div className=" cursor-not-allowed flex align-center justify-center rounded-action-btn ">
												<DeleteActionSvg />
											</div>
										)} */}
									</Space>
								);
							}}
						/>
					)}
				</Table>

				<div className={styles['pagination__wrapper']}>
					<Pagination
						current={currentPage}
						pageSize={pageSize}
						showSizeChanger
						onChange={onShowSizeChange}
						total={totalRecords}
						itemRender={(page, type, originalElement) => {
							return (
								<div className={styles['pagination']}>
									{type === 'prev' ? (
										<button
											className={`${styles['pagination']} ${styles['pagination__button']}`}
										>
											<TablePreviousIcon />
											<p
												className={
													styles['pagination__previous']
												}
											>
												Previous
											</p>
										</button>
									) : type === 'next' ? (
										<>
											<button
												className={`${styles['pagination']} ${styles['pagination__button']}`}
											>
												<p
													className={
														styles['pagination__next']
													}
												>
													Next
												</p>
												<TableNextIcon />
											</button>
										</>
									) : (
										originalElement
									)}
								</div>
							);
						}}
					/>
				</div>
			</div>
		</>
	);
};

export default CustomTable;
